// staging
// export const AppUrl = 'https://oplii-dev-api.azurewebsites.net';
export const AppUrl = 'https://oplii-dev-api.azurewebsites.net';
// 'https://api-staging.oplii.com/';
// 'https://oplii-staging-api.azurewebsites.net';
// local
//  https://oplii-dev-api.azurewebsites.net

// https://oplii-staging-api.azurewebsites.net

export const TELEMTRY_KEY = 'e3b5bfab-e1d3-4b00-9d97-0d840a758761';
export const MAX_FILE_UPLOAD = 50;
export const MAX_DOCUMENT_UPLOAD = 5;

export const GOOGLE_MAP_API_KEY = 'AIzaSyAmwbloJsGNDagTgYgzNPoxuLbfvouHYiE';
export const GOOGLE_MAP_ID = 'Google-Map-Id';
